import { useEffect, useState } from "react";
import { Sun, Moon } from "@phosphor-icons/react";

/**
 * Theme toggle rendered inline in the sidebar. Persists to localStorage and
 * toggles the `dark` class on <html> so Tailwind dark:variants can hook if needed.
 *
 * `variant="floating"` keeps the legacy fixed-position bubble (used only on
 * pages that don't render AppLayout, like /login).
 */
export default function ThemeToggle({ variant = "sidebar" }) {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("zm_theme");
    if (saved === "dark") {
      setDark(true);
      document.documentElement.classList.add("dark");
    }
  }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    if (next) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("zm_theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("zm_theme", "light");
    }
  };

  if (variant === "sidebar") {
    return (
      <button
        onClick={toggle}
        data-testid="theme-toggle-btn"
        title={dark ? "Trocar para tema claro" : "Trocar para tema escuro"}
        className="w-full flex items-center gap-3 px-3 py-2 text-sm text-[#c8d5cf] hover:bg-white/5 hover:text-white transition-colors duration-200"
      >
        {dark ? <Sun size={18} weight="bold" /> : <Moon size={18} weight="bold" />}
        {dark ? "Tema claro" : "Tema escuro"}
      </button>
    );
  }

  // Floating fallback (used on public pages)
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      title={dark ? "Tema claro" : "Tema escuro"}
      className="fixed bottom-5 left-5 z-30 h-10 w-10 rounded-full bg-[#0F4C3A] hover:bg-[#0A3629] text-white flex items-center justify-center shadow-brutal transition-transform hover:scale-110"
    >
      {dark ? <Sun size={18} weight="fill" /> : <Moon size={18} weight="fill" />}
    </button>
  );
}
